import loadCss from './loadCss';

export const loadVideoJs = () => {
  return import(/* webpackChunkName: "video" */ 'plyr');
};

export const loadVideoCSS = () => {
  return loadCss('/front_assets/plyr.css');
};
